import { FileURL } from 'shared/file';

export default new FileURL({ url: '/photos' });
